// extracted by mini-css-extract-plugin
module.exports = {"container":"CodeSnippet_container__AGtay"};